import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Divider, useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import { NavDrawerLinks } from "../NavDrawerLinkComponents/NavDrawerLinks";
import { OrderNowButton } from "../OrderNowButton";
import { NavLogOutLink } from "./NavLogOutLink";
import { useNavLinks } from "../hooks/useNavLinks";
import { getAccessibleTextColor } from "../../BrandingProvider/mealTrackThemeConfigurations";
export const MainLinksContent = () => {
    var _a;
    const { navDrawerBottomLinks, navDrawerTopLinks } = useNavLinks();
    const theme = useTheme();
    const headerBgColor = ((_a = theme.palette.header) === null || _a === void 0 ? void 0 : _a.backgroundColor) || theme.palette.common.white;
    const dividerColor = getAccessibleTextColor(theme, theme.palette.divider, headerBgColor);
    return (_jsxs(_Fragment, { children: [_jsx(OrderNowButton, { sx: { width: "75%", alignSelf: "center" } }), _jsxs(Stack, Object.assign({ spacing: 1 }, { children: [_jsx(NavDrawerLinks, { links: navDrawerTopLinks }), _jsx(Box, Object.assign({ width: "100%" }, { children: _jsx(Divider, { variant: "middle", sx: { mb: 2, borderColor: dividerColor } }) })), _jsx(NavDrawerLinks, { links: navDrawerBottomLinks }), _jsx(NavLogOutLink, { classes: "is-nav-drawer-logout" })] }))] }));
};
